export const HAKLAI_EXPENSE_ERRORS = Object.freeze({
  expenseTypeRequired: "יש לבחור סוג ניכוי",
  expenseTypeSubmitRequired: "סוג הניכוי הינו שדה חובה",
  expenseDateRequired: "יש להזין תאריך ניכוי",
  expenseDateInvalid: "תאריך הניכוי אינו תקין",
  expenseDateFuture: "תאריך הניכוי לא יכול להיות תאריך עתידי",
  expenseDateBeforeOwnershipStart: "תאריך הניכוי לא יכול להיות לפני תחילת הבעלות",
  expenseDateAfterSale: "תאריך הניכוי לא יכול להיות לאחר תאריך המכירה",
  masRehushUpTo72DateInvalid: "תאריך מס רכוש מסוג זה לא יכול להיות אחרי 31/03/1972",
  masRehushFrom72To86DateInvalid: "תאריך מס רכוש מסוג זה חייב להיות בין 01/04/1972 ל-31/12/1985",
  masRehushFrom86DateInvalid: "תאריך מס רכוש מסוג זה חייב להיות החל מ-01/01/1986",
  amountRequired: "יש להזין סכום ניכוי",
  currencyRequired: "יש לבחור מטבע",
  currencyInvalidForDate: "המטבע שנבחר אינו תקין עבור התאריך",
  targetPartRequired: "יש לבחור למי לייחס את הניכוי",
  targetPartInvalid: "יש לבחור חלק קיים עבור ייחוס הניכוי",
  zabanAttributionRequired: 'יש לבחור ייחוס זב"ן',
  zabanAttributionInvalid: 'ערך ייחוס זב"ן אינו תקין',
  depreciationDmmInvalid: "פחת דמ\"מ לניכוי אינו תקין",
  form11DepreciationAmountRequired: "יש להזין סכום פחת לפי טופס י\"א",
  purchaseDepreciationIncomplete: "יש להשלים את פחת הרכישה בטבלת מרכיבי הנכס",
  purchaseDepreciationMissing: "יש להגדיר תחילה פחת רכישה בטבלת מרכיבי הנכס",
  depreciationSelectionLimit: "ניתן לבחור עד 4 ניכויי פחת לכל רכיב"
});

export const HAKLAI_EXPENSE_LABELS = Object.freeze({
  sectionTitle: "ניכויים ופחת",
  deductions: "ניכויים",
  expenseType: "סוג ניכוי",
  expenseDate: "תאריך",
  amount: "סכום ההוצאה",
  currency: "מטבע",
  zabanAttribution: 'ייחוס זב"ן',
  calculatedDepreciation: "פחת מחושב",
  depreciationDeduction: "האם לנכות פחת",
  depreciationDeductionAria: "לנכות פחת",
  depreciationDeductionQuestion: "לנכות פחת?",
  purchaseForm11Depreciation: "פחת רכישה לפי טופס י\"א",
  form11Depreciation: "פחת לפי טופס י\"א",
  expenseTypePlaceholder: "בחר סוג ניכוי",
  purchaseZabanAttribution: 'ייחוס זב"ן דירה וזב"ן',
  commercialExpenseGroupBadge: "מסחרי"
});

export const HAKLAI_EXPENSE_ACTIONS = Object.freeze({
  enterDepreciation: "הזן פחת",
  addExpenseRow: "הוסף שורת ניכוי נוספת",
  unavailableAddExpenseRow: "לא ניתן להוסיף שורת ניכוי נוספת",
  confirmUnderstood: "הבנתי"
});

export const HAKLAI_EXPENSE_TOOLTIPS = Object.freeze({
  deleteExpense: "מחיקת ניכוי",
  chooseDepreciation: "בחירת ניכוי פחת לפי נתוני הרכיב",
  editForm11DepreciationAmount: "עריכת סכום פחת לפי טופס י\"א",
  enterForm11DepreciationAmount: "הזנת סכום פחת לפי טופס י\"א",
  enterPurchaseForm11DepreciationAmount: "הזנת סכום פחת רכישה לפי טופס י\"א",
  removeForm11Depreciation: "בטל כדי להסיר את פחת טופס י\"א מהניכוי",
  includeForm11Depreciation: "סמן כדי לכלול פחת לפי טופס י\"א",
  includeDmmDepreciationForAll: "סמן כדי לנכות פחת דמ\"מ לכל הרכיבים שהוגדרו",
  removeDmmDepreciation: "בטל כדי להסיר פחת דמ\"מ מהניכוי",
  includeDmmDepreciationForPart: "סמן כדי לנכות פחת דמ\"מ לפי נתוני הרכיב",
  noEligibleRentalPeriodAfterExpenseDate: "לא קיימת תקופת שכירות מזכה מתאריך ההוצאה ואילך",
  zeroCalculatedDepreciation: "הפחת המחושב הוא 0 לפי הנתונים שהוזנו",
  removePurchaseDepreciation: "בטל כדי להסיר את פחת הרכישה מהניתוח",
  includePurchaseDepreciation: "סמן כדי לכלול את פחת הרכישה בניתוח",
  purchaseDepreciationIncluded: "פחת הרכישה נכלל בניתוח",
  commercialExpenseGroup: "ניכויים לרכיב מסחרי"
});

export const HAKLAI_EXPENSE_POLICY_TEXTS = Object.freeze({
  depreciationSelectionLimitTitle: "לא ניתן לבחור יותר מ-4 רשומות פחת לאותו רכיב נכס",
  depreciationSelectionLimitText: "במערכת הדיווח המקוונת של מיסוי מקרקעין קיימת מגבלת קליטה ידועה של עד 4 רשומות פחת לרכיב נכס"
});

export const getHaklaiExpenseDeductionsHeader = (title = "") => {
  const normalizedTitle = String(title || "").trim();
  return normalizedTitle
    ? `${HAKLAI_EXPENSE_LABELS.deductions} ${normalizedTitle}`
    : HAKLAI_EXPENSE_LABELS.deductions;
};

export const getHaklaiExpenseForm11EditTooltip = (formattedAmount = "") => (
  `עריכת סכום פחת לפי טופס י"א (${formattedAmount} ₪)`
);
